export default "__VITE_ASSET__2e424ac2__"